var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "recruiting-detail" },
    [
      _vm.loading
        ? _c(
            "div",
            { staticClass: "text-center py-5" },
            [
              _c("md-empty-state", {
                attrs: { "md-label": "Loading opportunity…" }
              })
            ],
            1
          )
        : _vm.notFound
        ? _c(
            "div",
            { staticClass: "text-center py-5" },
            [
              _c(
                "md-empty-state",
                {
                  attrs: {
                    "md-label": "Opportunity not found",
                    "md-description":
                      "It may have been removed or you may be on a different community."
                  }
                },
                [
                  _c(
                    "md-button",
                    {
                      staticClass: "md-primary md-raised",
                      on: { click: _vm.goBackToList }
                    },
                    [_vm._v("Back to Recruiting")]
                  )
                ],
                1
              )
            ],
            1
          )
        : _vm.opportunity
        ? [
            _c(
              "md-card",
              { staticClass: "mt-20" },
              [
                _c("md-card-content", { staticClass: "header-meta" }, [
                  _c("div", { staticClass: "header-meta__status" }, [
                    _c(
                      "span",
                      {
                        class: [
                          "status-pill",
                          "status-pill--" + _vm.opportunity.status
                        ]
                      },
                      [
                        _c("span", { staticClass: "status-pill__dot" }),
                        _vm._v(
                          "\n            " +
                            _vm._s(_vm.statusLabel(_vm.opportunity.status)) +
                            "\n          "
                        )
                      ]
                    ),
                    _vm._v(" "),
                    _vm.isFavorited
                      ? _c("span", [
                          _c(
                            "button",
                            {
                              staticClass:
                                "btn custom-card-header-filter btn-transparent btn:focus",
                              attrs: { type: "button" },
                              on: { click: _vm.toggleFavorite }
                            },
                            [
                              _c(
                                "md-tooltip",
                                { attrs: { "md-direction": "bottom" } },
                                [_vm._v("unfavorite")]
                              ),
                              _vm._v(" "),
                              _c("i", {
                                staticClass: "fa fa-star fa-lg gold-color",
                                attrs: { "aria-hidden": "true" }
                              })
                            ],
                            1
                          )
                        ])
                      : _c("span", [
                          _c(
                            "button",
                            {
                              staticClass:
                                "btn custom-card-header-filter btn-transparent btn:focus",
                              attrs: { type: "button" },
                              on: { click: _vm.toggleFavorite }
                            },
                            [
                              _c(
                                "md-tooltip",
                                { attrs: { "md-direction": "bottom" } },
                                [_vm._v("favorite")]
                              ),
                              _vm._v(" "),
                              _c("i", {
                                staticClass: "far fa-star fa-lg",
                                attrs: { "aria-hidden": "true" }
                              })
                            ],
                            1
                          )
                        ])
                  ]),
                  _vm._v(" "),
                  _vm.availableActions.length
                    ? _c(
                        "div",
                        { staticClass: "header-actions" },
                        [
                          _c(
                            "md-button",
                            {
                              staticClass:
                                "md-raised md-round md-accent capitalize md-white-color send-matches-btn",
                              attrs: {
                                disabled:
                                  _vm.approvedCount === 0 || _vm.sendingMatches
                              },
                              on: { click: _vm.sendMatches }
                            },
                            [
                              _vm._v(
                                "\n            " +
                                  _vm._s(
                                    _vm.sendingMatches
                                      ? "Sending…"
                                      : _vm.approvedCount > 0
                                      ? "Send Matches (" +
                                        _vm.approvedCount +
                                        ")"
                                      : "Send Matches"
                                  ) +
                                  "\n          "
                              )
                            ]
                          ),
                          _vm._v(" "),
                          _vm.opportunity.status === "in_review"
                            ? [
                                _c(
                                  "md-button",
                                  {
                                    staticClass:
                                      "md-raised md-round md-accent capitalize md-white-color status-btn",
                                    style: {
                                      backgroundColor: _vm.STATUS_COLORS.active
                                    },
                                    attrs: { disabled: _vm.statusSaving },
                                    on: {
                                      click: function($event) {
                                        return _vm.applyStatusChange("active")
                                      }
                                    }
                                  },
                                  [
                                    _vm._v(
                                      "\n              Approve\n            "
                                    )
                                  ]
                                ),
                                _vm._v(" "),
                                _c(
                                  "md-button",
                                  {
                                    staticClass:
                                      "md-raised md-round md-accent capitalize md-white-color status-btn",
                                    style: {
                                      backgroundColor:
                                        _vm.STATUS_COLORS.rejected
                                    },
                                    attrs: { disabled: _vm.statusSaving },
                                    on: {
                                      click: function($event) {
                                        return _vm.applyStatusChange("rejected")
                                      }
                                    }
                                  },
                                  [
                                    _vm._v(
                                      "\n              Reject\n            "
                                    )
                                  ]
                                )
                              ]
                            : _vm._e(),
                          _vm._v(" "),
                          _c(
                            "span",
                            { staticClass: "header-actions__label m-left-10" },
                            [_vm._v("Change status to:")]
                          ),
                          _vm._v(" "),
                          _vm._l(_vm.availableActions, function(a) {
                            return _c(
                              "md-button",
                              {
                                key: a.value,
                                staticClass:
                                  "md-raised md-round md-accent capitalize md-white-color status-btn",
                                style: {
                                  backgroundColor: _vm.STATUS_COLORS[a.value]
                                },
                                attrs: { disabled: _vm.statusSaving },
                                on: {
                                  click: function($event) {
                                    return _vm.applyStatusChange(a.value)
                                  }
                                }
                              },
                              [
                                _vm._v(
                                  "\n            " +
                                    _vm._s(a.label) +
                                    "\n          "
                                )
                              ]
                            )
                          })
                        ],
                        2
                      )
                    : _vm._e()
                ])
              ],
              1
            ),
            _vm._v(" "),
            _c(
              "md-card",
              { staticClass: "mt-20 header-banner", style: _vm.communityStyle },
              [
                _c("div", { staticClass: "header-banner__row" }, [
                  _c("div", { staticClass: "header-banner__main" }, [
                    _c("h2", { staticClass: "header-banner__title" }, [
                      _vm._v(_vm._s(_vm.opportunity.title))
                    ]),
                    _vm._v(" "),
                    _c("div", { staticClass: "header-banner__company" }, [
                      _vm._v(_vm._s(_vm.opportunity.company))
                    ])
                  ])
                ])
              ]
            ),
            _vm._v(" "),
            _c("div", { staticClass: "detail-body mt-30" }, [
              _c(
                "div",
                { staticClass: "detail-body__main" },
                [
                  _c("md-card", { staticClass: "detail-card" }, [
                    _c("div", { staticClass: "detail-title" }, [
                      _vm._v("Description")
                    ]),
                    _vm._v(" "),
                    _vm.opportunity.description
                      ? _c("div", { staticClass: "detail-scroll" }, [
                          _vm._v(
                            "\n            " +
                              _vm._s(_vm.opportunity.description) +
                              "\n          "
                          )
                        ])
                      : _c("p", { staticClass: "empty-state" }, [
                          _vm._v("No description provided.")
                        ])
                  ]),
                  _vm._v(" "),
                  _c("md-card", { staticClass: "detail-card" }, [
                    _c("div", { staticClass: "detail-title" }, [
                      _vm._v("Required Skills")
                    ]),
                    _vm._v(" "),
                    _vm.opportunity.skills && _vm.opportunity.skills.length
                      ? _c(
                          "div",
                          { staticClass: "skills-chips" },
                          _vm._l(_vm.opportunity.skills, function(s) {
                            return _c(
                              "span",
                              { key: s, staticClass: "skill-chip" },
                              [_vm._v(_vm._s(s))]
                            )
                          }),
                          0
                        )
                      : _c("p", { staticClass: "empty-state" }, [
                          _vm._v("No skills specified.")
                        ])
                  ]),
                  _vm._v(" "),
                  _c("md-card", { staticClass: "detail-card" }, [
                    _c("div", { staticClass: "detail-title" }, [
                      _vm._v("Application")
                    ]),
                    _vm._v(" "),
                    _c("div", { staticClass: "field-label" }, [
                      _vm._v("Application URL")
                    ]),
                    _vm._v(" "),
                    _c("div", { staticClass: "field-value" }, [
                      _vm.opportunity.applicationUrl
                        ? _c(
                            "a",
                            {
                              staticClass: "field-value__link",
                              attrs: {
                                href: _vm.opportunity.applicationUrl,
                                target: "_blank",
                                rel: "noopener noreferrer"
                              }
                            },
                            [
                              _vm._v(
                                "\n              " +
                                  _vm._s(_vm.opportunity.applicationUrl) +
                                  "\n            "
                              )
                            ]
                          )
                        : _c("span", [_vm._v(_vm._s(_vm.EMPTY))])
                    ])
                  ])
                ],
                1
              ),
              _vm._v(" "),
              _c(
                "div",
                { staticClass: "detail-body__side" },
                [
                  _c("md-card", { staticClass: "detail-card" }, [
                    _c("div", { staticClass: "detail-title" }, [
                      _vm._v("Key Details")
                    ]),
                    _vm._v(" "),
                    _c("div", { staticClass: "field-grid" }, [
                      _c("div", { staticClass: "field-cell" }, [
                        _c("div", { staticClass: "field-label" }, [
                          _vm._v("Location")
                        ]),
                        _vm._v(" "),
                        _c("div", { staticClass: "field-value" }, [
                          _vm._v(_vm._s(_vm.opportunity.location || _vm.EMPTY))
                        ])
                      ]),
                      _vm._v(" "),
                      _c("div", { staticClass: "field-cell" }, [
                        _c("div", { staticClass: "field-label" }, [
                          _vm._v("Job Type")
                        ]),
                        _vm._v(" "),
                        _c("div", { staticClass: "field-value" }, [
                          _vm._v(_vm._s(_vm.opportunity.jobType || _vm.EMPTY))
                        ])
                      ]),
                      _vm._v(" "),
                      _c("div", { staticClass: "field-cell" }, [
                        _c("div", { staticClass: "field-label" }, [
                          _vm._v("Industry")
                        ]),
                        _vm._v(" "),
                        _c("div", { staticClass: "field-value" }, [
                          _vm._v(
                            "\n                " +
                              _vm._s(
                                _vm.opportunity.industry &&
                                  _vm.opportunity.industry.length
                                  ? _vm.opportunity.industry.join(", ")
                                  : _vm.EMPTY
                              ) +
                              "\n              "
                          )
                        ])
                      ]),
                      _vm._v(" "),
                      _c("div", { staticClass: "field-cell" }, [
                        _c("div", { staticClass: "field-label" }, [
                          _vm._v("Salary")
                        ]),
                        _vm._v(" "),
                        _c("div", { staticClass: "field-value" }, [
                          _vm._v(
                            "\n                " +
                              _vm._s(
                                _vm.opportunity.salary &&
                                  _vm.opportunity.salary.display
                                  ? _vm.opportunity.salary.display
                                  : _vm.EMPTY
                              ) +
                              "\n              "
                          )
                        ])
                      ]),
                      _vm._v(" "),
                      _c("div", { staticClass: "field-cell" }, [
                        _c("div", { staticClass: "field-label" }, [
                          _vm._v("Required Education")
                        ]),
                        _vm._v(" "),
                        _c("div", { staticClass: "field-value" }, [
                          _vm._v(
                            _vm._s(
                              _vm.displayEducation(
                                _vm.opportunity.requiredEducation
                              )
                            )
                          )
                        ])
                      ]),
                      _vm._v(" "),
                      _c("div", { staticClass: "field-cell" }, [
                        _c("div", { staticClass: "field-label" }, [
                          _vm._v("Required Experience")
                        ]),
                        _vm._v(" "),
                        _c("div", { staticClass: "field-value" }, [
                          _vm._v(
                            _vm._s(
                              _vm.displayExperience(
                                _vm.opportunity.requiredExperienceYears
                              )
                            )
                          )
                        ])
                      ])
                    ])
                  ]),
                  _vm._v(" "),
                  _c("md-card", { staticClass: "detail-card" }, [
                    _c("div", { staticClass: "detail-title" }, [
                      _vm._v("Posting Info")
                    ]),
                    _vm._v(" "),
                    _c("div", { staticClass: "field-cell" }, [
                      _c("div", { staticClass: "field-label" }, [
                        _vm._v("Submitted by")
                      ]),
                      _vm._v(" "),
                      _c("div", { staticClass: "field-value" }, [
                        _vm._v(_vm._s(_vm.submitterDisplay))
                      ])
                    ]),
                    _vm._v(" "),
                    _c("div", { staticClass: "field-cell" }, [
                      _c("div", { staticClass: "field-label" }, [
                        _vm._v("Date Submitted")
                      ]),
                      _vm._v(" "),
                      _c("div", { staticClass: "field-value" }, [
                        _vm._v(
                          _vm._s(_vm.displayDate(_vm.opportunity.submittedDate))
                        )
                      ])
                    ]),
                    _vm._v(" "),
                    _c("div", { staticClass: "field-cell" }, [
                      _c("div", { staticClass: "field-label" }, [
                        _vm._v("Expiration Date")
                      ]),
                      _vm._v(" "),
                      _c(
                        "div",
                        {
                          staticClass: "field-value",
                          class: { "field-value--expired": _vm.isExpired }
                        },
                        [
                          _vm._v(
                            _vm._s(
                              _vm.displayDate(
                                _vm.opportunity.deadline ||
                                  _vm.opportunity.expirationDate
                              )
                            )
                          )
                        ]
                      )
                    ]),
                    _vm._v(" "),
                    _c("div", { staticClass: "field-cell" }, [
                      _c("div", { staticClass: "field-label" }, [
                        _vm._v("Submitted Via")
                      ]),
                      _vm._v(" "),
                      _c("div", { staticClass: "field-value" }, [
                        _vm._v(
                          _vm._s(
                            _vm.displaySourceChannel(_vm.opportunity.source)
                          )
                        )
                      ])
                    ])
                  ])
                ],
                1
              )
            ]),
            _vm._v(" "),
            _c(
              "md-card",
              { staticClass: "mt-30" },
              [
                _c(
                  "md-card-expand",
                  [
                    _c(
                      "md-card-actions",
                      { attrs: { "md-alignment": "left" } },
                      [
                        _c(
                          "md-card-expand-trigger",
                          [
                            _c(
                              "md-button",
                              { staticClass: "expand-button-size" },
                              [
                                _c("strong", { staticClass: "upper-word" }, [
                                  _vm._v(
                                    "Matches (" +
                                      _vm._s(_vm.matchesInFlight.length) +
                                      ")"
                                  )
                                ])
                              ]
                            )
                          ],
                          1
                        ),
                        _vm._v(" "),
                        _c(
                          "router-link",
                          {
                            staticClass: "matches-recruiting-link upper-word",
                            attrs: {
                              to:
                                "/recruiting-match/" +
                                _vm.$route.params.opportunity_id
                            }
                          },
                          [_vm._v("\n            Recruiting\n          ")]
                        )
                      ],
                      1
                    ),
                    _vm._v(" "),
                    _c(
                      "md-card-expand-content",
                      [
                        _c(
                          "md-card-content",
                          [
                            _vm.matchesInFlight.length === 0
                              ? _c("p", { staticClass: "empty-state" }, [
                                  _vm._v(
                                    '\n              No matches approved yet. Click "Recruiting" above to run the\n              matching engine.\n            '
                                  )
                                ])
                              : [
                                  _vm.accordionSelectedIds.length > 0
                                    ? _c(
                                        "div",
                                        { staticClass: "matching-bulk-bar" },
                                        [
                                          _c(
                                            "span",
                                            {
                                              staticClass:
                                                "matching-bulk-bar__count"
                                            },
                                            [
                                              _c("strong", [
                                                _vm._v(
                                                  _vm._s(
                                                    _vm.accordionSelectedIds
                                                      .length
                                                  )
                                                )
                                              ]),
                                              _vm._v(
                                                " selected\n                "
                                              )
                                            ]
                                          ),
                                          _vm._v(" "),
                                          _c(
                                            "md-button",
                                            {
                                              staticClass:
                                                "md-raised md-accent md-round capitalize md-white-color md-orange",
                                              on: {
                                                click:
                                                  _vm.removeSelectedApprovedMatches
                                              }
                                            },
                                            [
                                              _vm._v(
                                                "\n                  Remove selected (" +
                                                  _vm._s(
                                                    _vm.accordionSelectedIds
                                                      .length
                                                  ) +
                                                  ")\n                "
                                              )
                                            ]
                                          ),
                                          _vm._v(" "),
                                          _c(
                                            "md-button",
                                            {
                                              staticClass:
                                                "md-raised md-round capitalize m-left-10",
                                              on: {
                                                click:
                                                  _vm.clearAccordionSelection
                                              }
                                            },
                                            [
                                              _vm._v(
                                                "\n                  Clear\n                "
                                              )
                                            ]
                                          )
                                        ],
                                        1
                                      )
                                    : _vm._e(),
                                  _vm._v(" "),
                                  _c(
                                    "md-table",
                                    { staticClass: "matching-table" },
                                    [
                                      _c(
                                        "md-table-row",
                                        [
                                          _c(
                                            "md-table-head",
                                            {
                                              staticClass:
                                                "card-header matching-select-col"
                                            },
                                            [
                                              _c("md-checkbox", {
                                                model: {
                                                  value:
                                                    _vm.allAccordionSelectedProxy,
                                                  callback: function($$v) {
                                                    _vm.allAccordionSelectedProxy = $$v
                                                  },
                                                  expression:
                                                    "allAccordionSelectedProxy"
                                                }
                                              })
                                            ],
                                            1
                                          ),
                                          _vm._v(" "),
                                          _c(
                                            "md-table-head",
                                            { staticClass: "card-header" },
                                            [_vm._v("Candidate")]
                                          ),
                                          _vm._v(" "),
                                          _c(
                                            "md-table-head",
                                            { staticClass: "card-header" },
                                            [_vm._v("Score")]
                                          ),
                                          _vm._v(" "),
                                          _c(
                                            "md-table-head",
                                            { staticClass: "card-header" },
                                            [_vm._v("Match reasons")]
                                          ),
                                          _vm._v(" "),
                                          _c(
                                            "md-table-head",
                                            { staticClass: "card-header" },
                                            [_vm._v("Email")]
                                          ),
                                          _vm._v(" "),
                                          _c(
                                            "md-table-head",
                                            { staticClass: "card-header" },
                                            [_vm._v("Status")]
                                          ),
                                          _vm._v(" "),
                                          _c(
                                            "md-table-head",
                                            {
                                              staticClass:
                                                "card-header matching-actions-col"
                                            },
                                            [_vm._v("Actions")]
                                          )
                                        ],
                                        1
                                      ),
                                      _vm._v(" "),
                                      _vm._l(_vm.matchesInFlight, function(m) {
                                        return _c(
                                          "md-table-row",
                                          { key: m.advisor_id },
                                          [
                                            _c(
                                              "md-table-cell",
                                              {
                                                staticClass:
                                                  "matching-select-col"
                                              },
                                              [
                                                m.status === "approved"
                                                  ? _c("md-checkbox", {
                                                      attrs: {
                                                        value: m.advisor_id
                                                      },
                                                      model: {
                                                        value:
                                                          _vm.accordionSelectedIds,
                                                        callback: function(
                                                          $$v
                                                        ) {
                                                          _vm.accordionSelectedIds = $$v
                                                        },
                                                        expression:
                                                          "accordionSelectedIds"
                                                      }
                                                    })
                                                  : _vm._e()
                                              ],
                                              1
                                            ),
                                            _vm._v(" "),
                                            _c(
                                              "md-table-cell",
                                              [
                                                _c(
                                                  "router-link",
                                                  {
                                                    staticClass:
                                                      "match-name-link",
                                                    attrs: {
                                                      to:
                                                        "/members/" +
                                                        m.advisor_id
                                                    }
                                                  },
                                                  [_vm._v(_vm._s(m.name))]
                                                ),
                                                _vm._v(" "),
                                                _c(
                                                  "div",
                                                  { staticClass: "match-sub" },
                                                  [
                                                    _vm._v(
                                                      "\n                      " +
                                                        _vm._s(
                                                          (
                                                            (m.dimensions &&
                                                              m.dimensions
                                                                .location) ||
                                                            []
                                                          )
                                                            .slice(0, 1)
                                                            .join("")
                                                        ) +
                                                        "\n                      "
                                                    ),
                                                    m.dimensions &&
                                                    m.dimensions.education &&
                                                    m.dimensions.education
                                                      .length
                                                      ? _c("span", [
                                                          _vm._v(
                                                            "\n                        · " +
                                                              _vm._s(
                                                                m.dimensions
                                                                  .education[0]
                                                              ) +
                                                              "\n                      "
                                                          )
                                                        ])
                                                      : _vm._e()
                                                  ]
                                                )
                                              ],
                                              1
                                            ),
                                            _vm._v(" "),
                                            _c("md-table-cell", [
                                              _vm._v(_vm._s(m.score + "%"))
                                            ]),
                                            _vm._v(" "),
                                            _c(
                                              "md-table-cell",
                                              _vm._l(_vm.matchTags(m), function(
                                                tag
                                              ) {
                                                return _c(
                                                  "span",
                                                  {
                                                    key: tag,
                                                    staticClass:
                                                      "skill-chip match-chip"
                                                  },
                                                  [_vm._v(_vm._s(tag))]
                                                )
                                              }),
                                              0
                                            ),
                                            _vm._v(" "),
                                            _c(
                                              "md-table-cell",
                                              { staticClass: "match-email" },
                                              [
                                                _vm._v(
                                                  "\n                    " +
                                                    _vm._s(m.email || "—") +
                                                    "\n                  "
                                                )
                                              ]
                                            ),
                                            _vm._v(" "),
                                            _c("md-table-cell", [
                                              _c(
                                                "span",
                                                {
                                                  class: _vm.statusColorClass(
                                                    m.status
                                                  )
                                                },
                                                [
                                                  _vm._v(
                                                    _vm._s(
                                                      _vm.statusMatchLabel(
                                                        m.status
                                                      )
                                                    )
                                                  )
                                                ]
                                              )
                                            ]),
                                            _vm._v(" "),
                                            _c(
                                              "md-table-cell",
                                              {
                                                staticClass:
                                                  "matching-actions-col"
                                              },
                                              [
                                                m.status === "approved"
                                                  ? _c(
                                                      "md-button",
                                                      {
                                                        staticClass:
                                                          "md-raised md-accent md-round capitalize md-white-color m-left-10 md-orange",
                                                        on: {
                                                          click: function(
                                                            $event
                                                          ) {
                                                            return _vm.removeApprovedMatch(
                                                              m.advisor_id
                                                            )
                                                          }
                                                        }
                                                      },
                                                      [
                                                        _vm._v(
                                                          "\n                      Remove\n                    "
                                                        )
                                                      ]
                                                    )
                                                  : _vm._e()
                                              ],
                                              1
                                            )
                                          ],
                                          1
                                        )
                                      })
                                    ],
                                    2
                                  )
                                ]
                          ],
                          2
                        )
                      ],
                      1
                    )
                  ],
                  1
                )
              ],
              1
            ),
            _vm._v(" "),
            _c(
              "md-card",
              { staticClass: "mt-30" },
              [
                _c(
                  "md-card-expand",
                  [
                    _c(
                      "md-card-actions",
                      { attrs: { "md-alignment": "space-between" } },
                      [
                        _c(
                          "md-card-expand-trigger",
                          [
                            _c(
                              "md-button",
                              { staticClass: "expand-button-size" },
                              [
                                _c("strong", { staticClass: "upper-word" }, [
                                  _vm._v(
                                    "Feedback (" +
                                      _vm._s(_vm.feedbackEntries.length) +
                                      ")"
                                  )
                                ])
                              ]
                            )
                          ],
                          1
                        )
                      ],
                      1
                    ),
                    _vm._v(" "),
                    _c(
                      "md-card-expand-content",
                      [
                        _c("md-card-content", [
                          _vm.feedbackEntries.length
                            ? _c(
                                "div",
                                { staticClass: "feedback-list" },
                                _vm._l(_vm.feedbackEntries, function(entry) {
                                  return _c(
                                    "div",
                                    {
                                      key: entry.id,
                                      staticClass: "feedback-row"
                                    },
                                    [
                                      _c(
                                        "div",
                                        { staticClass: "feedback-row__header" },
                                        [
                                          entry.memberId
                                            ? _c(
                                                "router-link",
                                                {
                                                  staticClass: "feedback-name",
                                                  attrs: {
                                                    to:
                                                      "/members/" +
                                                      entry.memberId
                                                  }
                                                },
                                                [
                                                  _vm._v(
                                                    "\n                    " +
                                                      _vm._s(entry.memberName) +
                                                      "\n                  "
                                                  )
                                                ]
                                              )
                                            : _c(
                                                "span",
                                                {
                                                  staticClass:
                                                    "feedback-name feedback-name--muted"
                                                },
                                                [
                                                  _vm._v(
                                                    "\n                    " +
                                                      _vm._s(entry.memberName) +
                                                      "\n                  "
                                                  )
                                                ]
                                              ),
                                          _vm._v(" "),
                                          _c(
                                            "span",
                                            {
                                              staticClass: "feedback-stars",
                                              attrs: {
                                                "aria-label":
                                                  entry.rating + " of 5 stars"
                                              }
                                            },
                                            _vm._l(5, function(n) {
                                              return _c(
                                                "span",
                                                {
                                                  key: n,
                                                  class: [
                                                    "feedback-star",
                                                    n <= entry.rating
                                                      ? "feedback-star--filled"
                                                      : ""
                                                  ]
                                                },
                                                [_vm._v("★")]
                                              )
                                            }),
                                            0
                                          ),
                                          _vm._v(" "),
                                          _c(
                                            "span",
                                            { staticClass: "feedback-when" },
                                            [
                                              _vm._v(
                                                _vm._s(
                                                  _vm.displayDateTime(
                                                    entry.submittedAt
                                                  )
                                                )
                                              )
                                            ]
                                          )
                                        ],
                                        1
                                      ),
                                      _vm._v(" "),
                                      entry.note
                                        ? _c(
                                            "p",
                                            { staticClass: "feedback-note" },
                                            [_vm._v(_vm._s(entry.note))]
                                          )
                                        : _c(
                                            "p",
                                            {
                                              staticClass:
                                                "feedback-note feedback-note--muted"
                                            },
                                            [_vm._v("No comment.")]
                                          )
                                    ]
                                  )
                                }),
                                0
                              )
                            : _c("p", { staticClass: "empty-state" }, [
                                _vm._v("No feedback submitted yet.")
                              ])
                        ])
                      ],
                      1
                    )
                  ],
                  1
                )
              ],
              1
            ),
            _vm._v(" "),
            _c(
              "md-card",
              { staticClass: "mt-30" },
              [
                _c(
                  "md-card-expand",
                  [
                    _c(
                      "md-card-actions",
                      { attrs: { "md-alignment": "space-between" } },
                      [
                        _c(
                          "md-card-expand-trigger",
                          [
                            _c(
                              "md-button",
                              { staticClass: "expand-button-size" },
                              [
                                _c("strong", { staticClass: "upper-word" }, [
                                  _vm._v(
                                    "Activity (" +
                                      _vm._s(_vm.activityEntries.length) +
                                      ")"
                                  )
                                ])
                              ]
                            )
                          ],
                          1
                        )
                      ],
                      1
                    ),
                    _vm._v(" "),
                    _c(
                      "md-card-expand-content",
                      [
                        _c("md-card-content", [
                          _vm.activityEntries.length
                            ? _c(
                                "div",
                                { staticClass: "activity-log" },
                                _vm._l(_vm.activityEntries, function(entry, i) {
                                  return _c(
                                    "div",
                                    {
                                      key: entry._id || i,
                                      staticClass: "activity"
                                    },
                                    [
                                      _c("b", [
                                        _vm._v(
                                          "\n                  " +
                                            _vm._s(
                                              _vm._f("momentDateUTC")(
                                                entry.when
                                              )
                                            ) +
                                            "\n                  "
                                        ),
                                        entry.memberName
                                          ? _c("span", [
                                              _vm._v(
                                                "- " + _vm._s(entry.memberName)
                                              )
                                            ])
                                          : _vm._e()
                                      ]),
                                      _vm._v(" "),
                                      entry.description
                                        ? _c(
                                            "p",
                                            { staticClass: "ask-description" },
                                            [_vm._v(_vm._s(entry.description))]
                                          )
                                        : _vm._e(),
                                      _vm._v(" "),
                                      entry.details
                                        ? _c(
                                            "p",
                                            { staticClass: "ask-description" },
                                            [_vm._v(_vm._s(entry.details))]
                                          )
                                        : _vm._e()
                                    ]
                                  )
                                }),
                                0
                              )
                            : _c("p", { staticClass: "empty-state" }, [
                                _vm._v("No activity yet.")
                              ])
                        ])
                      ],
                      1
                    )
                  ],
                  1
                )
              ],
              1
            )
          ]
        : _vm._e()
    ],
    2
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-a94a81f6", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-a94a81f6","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/RecruitingDetail.vue
// module id = null
// module chunks = 